export default "__VITE_ASSET__c7b25137__"